import type { CountryCapability } from "../../utils/catalogCountries";
import { SelectCountrySlot } from "./SelectCountrySlot";

export interface SelectOriginCountrySlotProps {
  countries: CountryCapability[];
  selected?: string | null;
  onSelect: (countryCode: string) => void;
  onClose: () => void;
  ns?: string;
}

export const SelectOriginCountrySlot: React.FC<SelectOriginCountrySlotProps> = (
  props
) => <SelectCountrySlot titleKey="transfer.selectOrigin" {...props} />;
